function deriveOnCompleteActions(node) {
  /**
   * Any info regarding where to redirect to, e.g. an expert application review page
   * or an inbox page if it's the end of a consumer request.
   */
  var terminalRedirectNodeResult = (node === null || node === void 0 ? void 0 : node.viewModel.__typename) === 'RedirectPathNodeFlowViewModel' ? node.viewModel.redirectResult : undefined;
  /**
   * The disambiguated sections of the dry run node. Less likely we'll care about these
   * on any application, but in the event its a dry run, surface that back to the user
   */

  var terminalDryRunNodeResult = (node === null || node === void 0 ? void 0 : node.viewModel.__typename) === 'DryRunInfoPathNodeFlowViewModel' ? node.viewModel.sections : undefined;
  return {
    redirectResult: terminalRedirectNodeResult,
    dryRunResult: terminalDryRunNodeResult
  };
}

export default deriveOnCompleteActions;
//# sourceMappingURL=deriveOnCompleteActions.js.map
